/**
 * Single source of truth for how a visitor reaches us.
 *
 * These were previously scattered as literals across the hero, the teams block,
 * the CTA banner and the footer — which is how the "Train your team" button
 * ended up pointing at a #services anchor that no longer existed. One constant
 * per channel means a number change is one edit, not a grep.
 *
 * Two numbers:
 *
 *   office   +974 4402 3030  landline, voice only
 *   mobile   +974 7055 5640  voice AND WhatsApp (WhatsApp moved here from
 *                            +974 5575 3005 on 2026-10-30)
 *
 * A wa.me link must only ever point at a number with a WhatsApp account:
 * wa.me happily renders a chat screen for an unregistered number, so a wrong
 * number fails silently.
 */
export const CONTACT_EMAIL = "info@fortmind.qa";
export const CONTACT_MAILTO = `mailto:${CONTACT_EMAIL}`;

/** WhatsApp line. E.164 without the +, as wa.me requires. */
export const WHATSAPP_NUMBER = "97470555640";
export const WHATSAPP_DISPLAY = "+974 7055 5640";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;

/** Voice lines. Office is the default; mobile is the direct line. */
export const PHONE_OFFICE_DISPLAY = "+974 4402 3030";
export const PHONE_OFFICE_TEL = "tel:+97444023030";
export const PHONE_MOBILE_DISPLAY = "+974 7055 5640";
export const PHONE_MOBILE_TEL = "tel:+97470555640";

/** Pre-filled WhatsApp opener, so the first message isn't a blank "hi". */
export function whatsappUrl(message?: string): string {
  return message
    ? `${WHATSAPP_URL}?text=${encodeURIComponent(message)}`
    : WHATSAPP_URL;
}
